import styled from "styled-components";

const HeaderWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  padding: 12px 16px 9px 16px;
  text-align: center;
`;

const HeaderTitle = styled.h1`
  font-size: 1.125rem;
  font-weight: bold;
  text-align: center;
`;

export { HeaderTitle, HeaderWrapper };
